import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { AuthService } from '../auth.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let authReq = req;

    const authorization = this.authService.getAuthorization();

    if (authorization) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${authorization.token}` },
      });
    }

    let handle = next.handle(authReq).pipe(
      catchError((err) => {
        if (err.status == 401) {
          //AuthEvents.onUnauthorized.emit();
          throw 'Unauthorized';
        }
        throw `Error ${err.status}`;
      })
    );

    return handle;
  }
}
